import http from "./http";

var baseUrl="/appuser-web/group";

/* 群组管理相关*/
/* 获取群组列表 */
const getGroupService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+'/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 新增群组 */
const addGroupService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl, reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 修改群组 */
const modifyGroupService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl, reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/* 删除群组 */
const deleteGroupService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl, reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 群组详情
const groupDetailService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl +  '/detail', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    })
}
// 群组添加成员
const addGroupUserService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl +  '/user', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    })
}
// 群组删除成员
const deleteGroupUserService = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl +  '/user', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    })
}

// 获取组织下默认群组
const getDefaultGroupApi = (reqParam) => {
  return new Promise((resolve, reject) => {
    http.get(baseUrl + '/org/default', reqParam, false).then(result => {
      resolve(result);
    }).catch(error => {
      reject(error);
    })
  })
}

export {
    getGroupService,   //群组列表
    addGroupService,  //添加群组
    modifyGroupService,  //修改群组
    deleteGroupService,   //删除群组
    groupDetailService,
    addGroupUserService,
    deleteGroupUserService,
    getDefaultGroupApi
}